<template>
    <v-card-text>
        <v-row class="mx-0" align="center" justify="end">
            <v-col cols="12" sm="auto" class="px-0">
                <v-btn color="primary" tile depressed @click="openDialog = true"
                    class="w-100 w-sm-auto font-weight-bold create-webinar-btn">
                    Create Webinar
                </v-btn>
            </v-col>
        </v-row>

        <!--  Create Webinar Form  -->
        <v-dialog v-model="openDialog" max-width="700px">
            <v-card class="mx-auto px-5 py-3" max-width="700px" outlined style="max-height: 90vh; overflow-y: auto">
                <v-row align="center" justify="space-between" class="mt-1 mx-0">
                    <v-col cols="10">
                        <h2 class="text-h4 font-weight-light">{{ isEditing ? 'Edit Webinar Details' : 'Webinar (Future Talks)' }}</h2>
                    </v-col>
                    <v-col cols="2" class="text-right">
                        <v-btn icon color="grey darken-1" @click="openDialog = false">
                            <v-icon class="dialog-close-icon" size="22">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-card-text>
                    <v-form>
                        <v-row class="mt-4">
                            <v-col cols="12">
                                <h4 class="text-left text-break">Webinar details</h4>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select v-model="month" :items="months" label="Webinar month" outlined dense
                                    placeholder="Select Month" :error-messages="errorMonth"></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition"
                                    offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="date" label="Webinar date" outlined dense readonly
                                            :error-messages="errorDate" v-bind="attrs" v-on="on"
                                            placeholder="Select Date">
                                            <template v-slot:append>
                                                <v-icon v-on="on">mdi-calendar</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" @input="dateMenu = false" no-title></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" sm="12" md="4">
                                <v-menu ref="menu" v-model="timeMenu" :close-on-content-click="false" :nudge-right="40"
                                    :return-value.sync="time" transition="scale-transition" offset-y max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :value="formattedTimeDisplay" label="Webinar time" outlined dense
                                            readonly :error-messages="errorTime" v-bind="attrs" v-on="on"
                                            placeholder="Select Time">
                                            <template v-slot:append>
                                                <v-icon v-on="on">mdi-clock-outline</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>

                                    <v-time-picker v-if="timeMenu" v-model="time" full-width format="ampm"
                                        @click:minute="$refs.menu.save(time)">
                                    </v-time-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="title" label="Webinar title" outlined dense
                                    placeholder="Webinar Title" :error-messages="errorTitle"></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <!-- <div class="text-subtitle-1 mb-1 grey--text text--darken-1">Details</div> -->
                                <quill-editor v-model="details" ref="myQuillEditor" :options="editorOption" class="mb-2"
                                    :class="{ 'error-border': !!errorDetails }" />

                                <div v-if="errorDetails" class="v-text-field__details mt-2 ml-2">
                                    <div class="v-messages theme--light error--text" role="alert">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">{{ errorDetails }}</div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>

                            <v-col cols="12" class="pt-0">
                                <h4 class="text-left text-break">Speaker's details</h4>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="speakerName" label="Speaker's name" outlined dense
                                    placeholder="Speaker Name" :error-messages="errorSpeakerName"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-file-input v-model="speakerImage" label="Speaker's image" outlined dense
                                    accept="image/*" append-icon="mdi-paperclip" prepend-icon=""
                                    :error-messages="errorSpeakerImage">
                                </v-file-input>
                            </v-col>

                            <v-col cols="12" class="pt-0">
                                <h4 class="text-left text-break">Registration Link</h4>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="registrationLink" label="Webinar registration link" outlined
                                    dense placeholder="https://example.com/register"
                                    :error-messages="errorRegistrationLink"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-row justify="center" class="mb-6 mt-4">
                    <v-btn class="create-webinar-btn" color="secondary" dark depressed @click="submitWebinar"
                        :loading="isLoading">{{
                            isEditing ? 'Update Webinar' : 'Create Webinar' }}
                    </v-btn>
                </v-row>
            </v-card>
        </v-dialog>

        <!--  Delete Confirmation Dialog  -->
        <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <h3 class="title text-start"> Are you sure you want to delete this webinar? </h3>
                </v-card-title>
                <v-card-text>
                    <p class="subtitle-2 text-left"> You will be permanently deleting all the data associated with this
                        webinar.
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="deleteDialog = false"> No, Cancel </v-btn>
                    <v-btn color="error" text @click="confirmDelete" :loading="isLoading"> Yes, Delete </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div v-if="loadingData" class="text-center mt-5">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>

        <!-- Webinar List -->
        <div v-else class="mt-5">
            <v-data-iterator :items="webinars" :items-per-page.sync="itemsPerPage" :page.sync="page"
                :footer-props="footerProps" hide-default-header>
                <template v-slot:default="props">
                    <v-card v-for="(item, index) in props.items" :key="item._id || index"
                        class="mb-10 pa-6 d-flex flex-column" outlined>
                        <v-row class="d-flex flex-grow-1">
                            <v-col cols="12" sm="3" md="2" class="text-center d-flex flex-column align-center mt-2">
                                <v-avatar size="120" class="mb-3">
                                    <img :src="item.speakerImage" :alt="item.speakerName" style="object-fit: cover;">
                                </v-avatar>
                                <div class="font-weight-bold">
                                    {{ item.speakerName }}</div>
                            </v-col>

                            <v-col cols="12" sm="9" md="10" class="d-flex flex-column">
                                <div class="d-flex justify-space-between align-start text-body-1">
                                    <div>
                                        <div class="d-flex align-items-start mb-3">

                                            <div class="font-weight-bold flex-shrink-0 mr-2">
                                                {{ item.month }} –
                                            </div>

                                            <div class="font-weight-regular text-justify" style="line-height: 1.6;">
                                                {{ item.title }}
                                            </div>
                                        </div>
                                        <div>
                                            <span class="font-weight-bold">Date</span> –
                                            <span class="font-weight-regular">{{ formatDate(item.date) }},</span>
                                            <span class="font-weight-regular ml-3">{{ formatTimeForDisplay(item.time)
                                            }}</span>
                                        </div>
                                    </div>

                                    <div class="d-flex" :class="{ 'flex-column': $vuetify.breakpoint.smAndDown }">
                                        <v-btn color="primary" depressed small @click="openEditDialog(item)"
                                            class="create-webinar-btn font-weight-bold px-5"
                                            :class="$vuetify.breakpoint.smAndDown ? 'ml-1 mt-2' : 'ml-4'">
                                            <v-icon left small>mdi-pencil</v-icon> EDIT
                                        </v-btn>
                                        <v-btn color="red" depressed small @click="openDeleteDialog(item._id)"
                                            class="create-webinar-btn font-weight-bold"
                                            :class="$vuetify.breakpoint.smAndDown ? 'ml-1 mt-2' : 'ml-2'">
                                            <v-icon left small>mdi-delete</v-icon> DELETE
                                        </v-btn>
                                    </div>
                                </div>

                                <div class="mt-3 mr-2 text-subtitle-1 grey--text text--darken-3 flex-grow-1">
                                    <div v-html="item.details" class="quill-content"></div>
                                </div>

                                <div class="mt-auto pt-3">
                                    <v-row>
                                        <v-col cols="12" md="6" sm="10">
                                            <v-btn small height="32" color="primary" depressed block
                                                :href="item.registrationLink" target="_blank"
                                                class="create-webinar-btn subtitle-2 letter-spacing-1 font-weight-bold">
                                                REGISTER FOR THIS FUTURE TALK
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </template>

                <template v-slot:no-data>
                    <p class="text-center grey--text mt-5">No webinars found.</p>
                </template>
            </v-data-iterator>
        </div>

    </v-card-text>
</template>

<script>
import ContentService from "../../../services/content.service";
import Upload from "../../../services/imageUpload.service";

// QUILL EDITOR IMPORTS
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
    name: "Webinar",
    components: {
        quillEditor
    },
    data: () => ({
        isLoading: false,
        loadingData: false,
        webinars: [],
        openDialog: false,
        deleteDialog: false,
        webinarToDeleteId: null,
        isEditing: false,
        editingId: null,
        currentSpeakerImage: null,

        // Pagination Data
        page: 1,
        itemsPerPage: 5,
        footerProps: {
            "items-per-page-options": [5, 10, 20, -1],
            "show-current-page": true,
            "show-first-last-page": true
        },

        dateMenu: false,
        timeMenu: false,
        months: [
            'January', 'February', 'March', 'April', 'May', 'June', 'July',
            'August', 'September', 'October', 'November', 'December'
        ],
        month: null,
        date: null,
        title: '',
        time: null,
        details: '',
        speakerName: '',
        speakerImage: null,
        registrationLink: '',
        // Errors
        errorMonth: null,
        errorDate: null,
        errorTime: null,
        errorTitle: null,
        errorDetails: null,
        errorSpeakerName: null,
        errorSpeakerImage: null,
        errorRegistrationLink: null,

        // EDITOR OPTIONS
        editorOption: {
            placeholder: 'Enter webinar details here...',
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'align': [] }],
                    ['clean']
                ]
            }
        },
    }),
    computed: {
        // Formats the time from 24-hour to 12-hour format with AM/PM for display
        formattedTimeDisplay() {
            if (!this.time) return null;

            const [hours, minutes] = this.time.split(':');
            let h = parseInt(hours, 10);
            const ampm = h >= 12 ? 'PM' : 'AM';
            h = h % 12;
            h = h ? h : 12;
            const formattedHour = h < 10 ? '0' + h : h;

            return `${formattedHour}:${minutes} ${ampm}`;
        }
    },
    mounted() {
        this.fetchWebinars();
    },
    watch: {
        openDialog(val) {
            if (!val) {
                this.resetForm();
            }
        },
        month() { this.errorMonth = null; },
        date() { this.errorDate = null; },
        time() { this.errorTime = null; },
        title() { this.errorTitle = null; },
        details() { this.errorDetails = null; },
        speakerName() { this.errorSpeakerName = null; },
        speakerImage() { this.errorSpeakerImage = null; },
        registrationLink() { this.errorRegistrationLink = null; },
    },
    methods: {
        // --- Fetch Data ---
        async fetchWebinars() {
            this.loadingData = true;
            try {
                const response = await ContentService.getWebinars();
                this.webinars = response.data.content || [];
            } catch (error) {
                console.error("Error fetching webinars:", error);
            } finally {
                this.loadingData = false;
            }
        },

        // --- Delete Data ---
        openDeleteDialog(id) {
            this.webinarToDeleteId = id;
            this.deleteDialog = true;
        },
        async confirmDelete() {
            this.isLoading = true;
            try {
                await ContentService.deleteWebinar(this.webinarToDeleteId);
                this.$store.dispatch("notify/setSnackbarMessage", {
                    snackBarText: "Webinar has been deleted successfully!",
                    snackBarColor: "green",
                });
                this.fetchWebinars();
            } catch (error) {
                console.error("Error deleting webinar:", error);
                this.$store.dispatch("notify/setSnackbarMessage", {
                    snackBarText: "There was an error deleting the webinar.",
                    snackBarColor: "red",
                });
            } finally {
                this.deleteDialog = false;
                this.webinarToDeleteId = null;
                this.isLoading = false;
            }
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const getDayWithSuffix = (day) => {
                if (day > 3 && day < 21) return `${day}th`;
                switch (day % 10) {
                    case 1: return `${day}st`;
                    case 2: return `${day}nd`;
                    case 3: return `${day}rd`;
                    default: return `${day}th`;
                }
            };

            const date = new Date(dateString);
            const day = getDayWithSuffix(date.getUTCDate());
            const month = date.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
            const year = date.getUTCFullYear();
            return `${day} ${month} ${year}`;
        },

        formatTimeForDisplay(time) {
            if (!time) return '';

            const [hours, minutes] = time.split(':');
            let h = parseInt(hours, 10);
            const ampm = h >= 12 ? 'PM' : 'AM';
            h = h % 12;
            h = h ? h : 12; // the hour '0' should be '12'
            const formattedHour = h < 10 ? '0' + h : h;

            return `${formattedHour}:${minutes} ${ampm}`;
        },
        openEditDialog(item) {
            this.isEditing = true;
            this.editingId = item._id;
            this.month = item.month;
            this.date = item.date;
            this.time = item.time;
            this.title = item.title;
            this.details = item.details;
            this.speakerName = item.speakerName;
            this.currentSpeakerImage = item.speakerImage;
            this.speakerImage = null; // Reset file input
            this.registrationLink = item.registrationLink;
            this.openDialog = true;
        },
        // --- Submit Data ---
        async submitWebinar() {
            const isValid = this.validateForm();
            if (isValid) {
                this.isLoading = true;

                const toBase64 = (file) =>
                    new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = (error) => reject(error);
                    });

                let imageUrl = this.isEditing ? this.currentSpeakerImage : null;

                // Handle image upload
                if (this.speakerImage && typeof this.speakerImage === 'object') {
                    let imagePayload = {
                        Path: `webinars/speakers/${this.speakerName.replace(/\s+/g, '-')}-${Number(new Date())}.jpg`,
                        Base64: await toBase64(this.speakerImage),
                    };
                    try {
                        const imageResponse = await Upload.imageUpload(imagePayload);
                        imageUrl = imageResponse.data.content;
                    } catch (err) {
                        console.error("Image upload failed", err);
                        this.isLoading = false;
                        return;
                    }
                }

                try {
                    const webinarData = {
                        month: this.month,
                        date: this.date,
                        time: this.time,
                        title: this.title,
                        details: this.details,
                        speakerName: this.speakerName,
                        speakerImage: imageUrl,
                        registrationLink: this.registrationLink,
                    };

                    if (this.isEditing) {
                        await ContentService.editWebinar(this.editingId, webinarData);
                        this.$store.dispatch("notify/setSnackbarMessage", {
                            snackBarText: "Webinar has been updated successfully!",
                            snackBarColor: "green",
                        });
                    } else {
                        await ContentService.createWebinar(webinarData);
                        this.$store.dispatch("notify/setSnackbarMessage", {
                            snackBarText: "Webinar has been created successfully!",
                            snackBarColor: "green",
                        });
                    }

                    this.openDialog = false;
                    this.fetchWebinars();
                } catch (error) {
                    console.error("Error creating webinar:", error);
                    this.$store.dispatch("notify/setSnackbarMessage", {
                        snackBarText: "There was an error creating the webinar.",
                        snackBarColor: "red",
                    });
                } finally {
                    this.isLoading = false;
                }
            }
        },
        validateForm() {
            let isValid = true;
            if (!this.month) {
                this.errorMonth = 'Webinar month is required.';
                isValid = false;
            }
            if (!this.date) {
                this.errorDate = 'Webinar date is required.';
                isValid = false;
            }
            if (!this.time) {
                this.errorTime = 'Webinar time is required.';
                isValid = false;
            }
            if (!this.title) {
                this.errorTitle = 'Webinar title is required.';
                isValid = false;
            }
            if (!this.details) {
                this.errorDetails = 'Webinar details are required.';
                isValid = false;
            }
            if (!this.speakerName) {
                this.errorSpeakerName = "Speaker's name is required.";
                isValid = false;
            }
            if (!this.speakerImage && !this.isEditing) {
                this.errorSpeakerImage = "Speaker's image is required.";
                isValid = false;
            }
            if (!this.registrationLink.trim()) {
                this.errorRegistrationLink = 'Registration link is required.';
                isValid = false;
            } else {
                const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
                if (!urlPattern.test(this.registrationLink)) {
                    this.errorRegistrationLink = 'Please enter a valid registration link.';
                    isValid = false;
                }
            }
            return isValid;
        },
        resetForm() {
            this.month = null;
            this.date = null;
            this.time = null;
            this.title = '';
            this.details = '';
            this.speakerName = '';
            this.speakerImage = null;
            this.registrationLink = '';
            this.errorMonth = null;
            this.errorTime = null;
            this.errorDate = null;
            this.errorTitle = null;
            this.errorDetails = null;
            this.errorSpeakerName = null;
            this.errorSpeakerImage = null;
            this.errorRegistrationLink = null;
            this.isEditing = false;
            this.editingId = null;
            this.currentSpeakerImage = null;
        }
    }
};
</script>

<style scoped>
/* --- TIME PICKER STYLING --- */
::v-deep .v-time-picker-title__ampm .v-picker__title__btn--active {
    color: white !important;
    font-weight: bolder !important;
    font-size: 24px !important;
}

.create-webinar-btn:hover {
    filter: brightness(85%);
    transition: filter 0.2s ease-in-out;
}

/* --- QUILL EDITOR INPUT STYLING --- */
::v-deep .ql-editor {
    min-height: 150px;
    font-size: 16px;
}

::v-deep .ql-editor li {
    margin-left: 0px;
}

::v-deep .ql-editor ul,
::v-deep .ql-editor ol {
    padding-left: 32px !important;
    margin-bottom: 16px !important;
}

::v-deep .ql-editor ul li {
    list-style-type: disc !important;
}

::v-deep .ql-editor ol li {
    list-style-type: decimal !important;
}

::v-deep .ql-editor strong,
::v-deep .ql-editor b {
    font-weight: bold !important;
}

/* --- QUILL EDITOR DISPLAY STYLING --- */
.quill-content {
    line-height: 1.3 !important;
}

.quill-content ::v-deep p {
    margin-bottom: 4px !important;
    margin-top: 0px !important;
}

.quill-content ::v-deep ul,
.quill-content ::v-deep ol {
    padding-left: 32px !important;
    margin-bottom: 8px !important;
    margin-top: 0px !important;
}

.quill-content ::v-deep li {
    margin-bottom: 2px !important;
}

.quill-content ::v-deep .ql-align-center {
    text-align: center;
}

.quill-content ::v-deep .ql-align-right {
    text-align: right;
}

.quill-content ::v-deep .ql-align-justify {
    text-align: justify;
}

.error-border ::v-deep .ql-toolbar,
.error-border ::v-deep .ql-container {
    border-color: #ff5252 !important;
    border-width: 2.5px;
}
</style>